import _, { Many } from "lodash";

export const mergeArraysOfObjectsByProp = <T>(
  a: T[],
  b: T[],
  prop: keyof T,
  order: Many<boolean | "asc" | "desc"> = "asc",
  orderByProp?: keyof T
): T[] => {
  const merged = _.unionBy(a, b, prop);
  return orderByProp ? _.orderBy(merged, orderByProp, order) : merged;
};
